import { Store } from 'types';

export const stateSelector = (state: Store): Store => state;
